import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

import { TimeagoModule } from 'ngx-timeago';

@Component({
  selector: 'app-welcome',
  imports: [TimeagoModule,],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.css'
})
export class WelcomeComponent implements OnInit {


    private _httpClient = inject(HttpClient);

    systemCheck = 'Checking System...';
    patientCheck = 'Checking Patient...';
    cateringCheck = 'Checking Catering...';
    inventoryCheck = 'Checking Inventory...';

    baseAddress = environment.isLocal ? '' : environment.api.baseAddress;

    async ngOnInit() {
        await this.performChecks();
    }

    async performChecks() {
        try{
            await this._httpClient.get( this.baseAddress + environment.api.system.healthCheck).toPromise();
            this.systemCheck = "System OK";
        } catch(err){
            this.systemCheck = "System Error";
            console.log("System Check Failed");
            console.log(err);
        }

        try{
            await this._httpClient.get(this.baseAddress + environment.api.patient.healthCheck).toPromise();
            this.patientCheck = "Patient OK";
        } catch(err){
            this.patientCheck = "Patient Error";
            console.log("Patient Check Failed");
            console.log(err);
        }

        try{
            await this._httpClient.get(this.baseAddress + environment.api.catering.healthCheck).toPromise();
            this.cateringCheck = "Catering OK";
        } catch(err){
            this.cateringCheck = "Catering Error";
            console.log("Catering Check Failed");
            console.log(err);
        }

        try{
            await this._httpClient.get(this.baseAddress + environment.api.inventory.healthCheck).toPromise();
            this.inventoryCheck = "Inventory OK";
        } catch(err){
            this.inventoryCheck = "Inventory Error";
            console.log("Inventory Check Failed");
            console.log(err);
        }
    }

    goHome() {
        location.href = location.origin;
    }


}
